import { apiEndpoints } from 'settings/_apiSettings'
import axios from 'settings/axios'

export interface MedicalRequestPayload {
  medical_request: string;
  issue_date: string;
  cid_id: number;
  professional_name: string;
  professional_document_number: string;
  professionaL_document_state: string;
  sessions?: number;
  specialty_id: number;
  patient_username?: string;
  plan_code?: string;
}

interface MedicalRequestParams {
  data: MedicalRequestPayload;
  username: string;
}

interface CreateMedicalRequestResponse {
  uuid: string;
}

const createMedicalRequest = async ({
  username,
  data
}: MedicalRequestParams): Promise<CreateMedicalRequestResponse> => {
  const endpoint = apiEndpoints.PATIENTS_MEDICAL_REQUEST_BY_USERNAME(username)
  const result: CreateMedicalRequestResponse = await axios.post(endpoint, data)
  return result
}

export { createMedicalRequest }
